import React, { createContext, useContext, useReducer, useEffect } from 'react';

const CopywriterContext = createContext(null);

const CopywriterDispatchContext = createContext(null);


export const CopywriterProvider = ({ children, ...props }) => {
  const { prompt, content, onChange, onCancel } = props;

  const [copywriter, dispatch] = useReducer(
    copywriterReducer,
    {...initialCopywriter, content, onChange, onCancel}
  );

  useEffect(() => {
    dispatch({ type: 'update', payload: { prompt, content, onChange, onCancel, result: null } });
    if (prompt) setTimeout(() => dispatch({ type: 'emit_fetching' }), 100);

  }, [content, onChange, onCancel]);

  return (
    <CopywriterContext.Provider value={copywriter}>
      <CopywriterDispatchContext.Provider value={dispatch}>
        {children}
      </CopywriterDispatchContext.Provider>
    </CopywriterContext.Provider>
  );
}

export const useCopywriter = () => {
  return useContext(CopywriterContext);
}

export const useCopywriterDispatch = () => {
  return useContext(CopywriterDispatchContext);
}

const copywriterReducer = (copywriter, action) => {
  switch (action.type) {
    case 'toggle': {
      return {...copywriter, open: !copywriter.open};
    }

    case 'update': {
      return {...copywriter, ...action.payload };
    }

    case 'update_content': {
      return {...copywriter, content: action.content };
    }
    
    case 'update_prompt': {
      return {...copywriter, prompt: action.prompt };
    }

    case 'update_result': {
      return {...copywriter, result: action.result };
    }

    case 'emit_fetching': {
      return {...copywriter, fetching: true };
    }

    case 'emit_clear_fetching': {
      return {...copywriter, fetching: false };
    }

    case 'error': {
      // busy, frequency_limit_reached, empty_response, network
      return {...copywriter, error: action.error};
    }

    default: {
      throw Error('Unknown action: ' + action.type);
    }
  }
}

const initialCopywriter = { 
  open: false,
  // fetching: ,
  prompt: ''
}; 
